// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3Pju1","footer":"ModalFilter_footer__3VCTs"};